"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertPage = exports.AlertSections = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var classnames_1 = require("classnames");
var searchSetToAlertValue_1 = require("@/transformers/searchSetToAlertValue");
var AlertAction_1 = require("@/pages/alert/actions/AlertAction");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var MemberPage_1 = require("@/pages/common/components/MemberPage");
var NotificationChannelTypes_1 = require("@/pages/alert/states/NotificationChannelTypes");
var AlertSections;
(function (AlertSections) {
    AlertSections[AlertSections["SAVED_SEARCHES"] = 1] = "SAVED_SEARCHES";
    AlertSections[AlertSections["FOLLOWINGS"] = 2] = "FOLLOWINGS";
})(AlertSections = exports.AlertSections || (exports.AlertSections = {}));
var mapStateToProps = function (state) { return (__assign(__assign({}, state.alert), { languageCode: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, isAllSavedSearchesEmailChecked: state.alert.savedSearches
        .map(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) > -1; })
        .indexOf(false) === -1, isAllSavedSearchesMobileChecked: state.alert.savedSearches
        .map(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) > -1; })
        .indexOf(false) === -1, isAllFollowingPlacesEmailChecked: state.alert.followingPlaces
        .map(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) > -1; })
        .indexOf(false) === -1, isAllFollowingPlacesMobileChecked: state.alert.followingPlaces
        .map(function (it) { return it.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) > -1; })
        .indexOf(false) === -1 })); };
var mapDispatchToProps = function (dispatch) { return ({
    onChangeSaveSearchAlert: function (id, frequency) {
        return dispatch(AlertAction_1.default.onChangeSaveSearchAlert(id, frequency));
    },
    onChangeSaveSearchEmailEnabled: function (id) {
        return dispatch(AlertAction_1.default.onChangeSaveSearchEmailEnabled(id));
    },
    onChangeSaveSearchMobileEnabled: function (id) {
        return dispatch(AlertAction_1.default.onChangeSaveSearchMobileEnabled(id));
    },
    onChangeFollowingEmailEnabled: function (id) {
        return dispatch(AlertAction_1.default.onChangeFollowingEmailEnabled(id));
    },
    onChangeFollowingMobileEnabled: function (id) {
        return dispatch(AlertAction_1.default.onChangeFollowingMobileEnabled(id));
    },
    onChangeMarketUpdate: function () { return dispatch(AlertAction_1.default.onChangeMarketUpdate()); },
    onClickAllSavedSearchesEmail: function () {
        return dispatch(AlertAction_1.default.onClickAllSavedSearchesEmail());
    },
    onClickAllSavedSearchesMobile: function () {
        return dispatch(AlertAction_1.default.onClickAllSavedSearchesMobile());
    },
    onClickAllFollowingPlacesEmail: function () {
        return dispatch(AlertAction_1.default.onClickAllFollowingPlacesEmail());
    },
    onClickAllFollowingPlacesMobile: function () {
        return dispatch(AlertAction_1.default.onClickAllFollowingPlacesMobile());
    },
    onAlertSave: function () { return dispatch(AlertAction_1.default.onAlertSave()); },
    onUnsubscribeClicked: function () { return dispatch(AlertAction_1.default.onUnsubscribeClicked()); },
}); };
exports.alertPage = function (props) {
    var renderAlert = function (props) {
        var renderAlerts = function (props) {
            var onMarketEnableChanged = function () {
                props.onChangeMarketUpdate();
            };
            var renderAlertRows = function (searchSets, props, alertSection) {
                var renderAlertRow = function (searchSet, index, props) {
                    var onSelectChanged = function (event) {
                        var frequency = parseInt(event.currentTarget.value, 10);
                        props.onChangeSaveSearchAlert(searchSet.userSearchSetId, frequency);
                    };
                    var alertValue = searchSetToAlertValue_1.toAlertValue(searchSet.notificationEnabled, searchSet.notificationFrequency);
                    var renderOptions = function (props) {
                        return searchSetToAlertValue_1.getAlertValues().map(function (it, index) {
                            return (React.createElement("option", { key: index, value: it.value }, props.t[it.key]));
                        });
                    };
                    var emailChecked = searchSet.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.Email) >= 0;
                    var mobileChecked = searchSet.notificationChannels.indexOf(NotificationChannelTypes_1.NotificationChannelTypes.AppPush) >= 0;
                    var onChangeSaveSearchEmail = function () {
                        return alertSection === AlertSections.SAVED_SEARCHES
                            ? props.onChangeSaveSearchEmailEnabled(searchSet.notificationId)
                            : props.onChangeFollowingEmailEnabled(searchSet.notificationId);
                    };
                    var onChangeSaveSearchMobile = function () {
                        return alertSection === AlertSections.SAVED_SEARCHES
                            ? props.onChangeSaveSearchMobileEnabled(searchSet.notificationId)
                            : props.onChangeFollowingMobileEnabled(searchSet.notificationId);
                    };
                    return (React.createElement("div", { key: index, className: "c-tabler__row" },
                        React.createElement("div", { className: "c-tabler__rowgroup" },
                            React.createElement("div", { className: "c-tabler__item" },
                                React.createElement("span", { className: "fal fa-search" }),
                                " ",
                                searchSet.name)),
                        React.createElement("div", { className: "c-tabler__rowgroup" },
                            React.createElement("div", { className: "c-tabler__item" },
                                React.createElement("span", { className: "c-tabler__mobile-text" }, props.t.email),
                                React.createElement("label", { className: "c-tabler__switch" },
                                    React.createElement("input", { type: "checkbox", className: "c-tabler__input", onChange: onChangeSaveSearchEmail, checked: emailChecked }),
                                    React.createElement("span", { className: "c-tabler__slider" }))),
                            React.createElement("div", { className: "c-tabler__item" },
                                React.createElement("span", { className: "c-tabler__mobile-text" }, props.t.mobile),
                                React.createElement("label", { className: "c-tabler__switch" },
                                    React.createElement("input", { type: "checkbox", className: "c-tabler__input", onChange: onChangeSaveSearchMobile, checked: mobileChecked }),
                                    React.createElement("span", { className: "c-tabler__slider" }))),
                            React.createElement("div", { className: "c-tabler__item" },
                                React.createElement("span", { className: "c-tabler__mobile-text" }, props.t.frequency),
                                React.createElement("select", { value: alertValue, onChange: onSelectChanged, className: "c-tabler__dropdown", disabled: !searchSet.notificationChannels.length }, renderOptions(props))))));
                };
                return searchSets.map(function (it, index) {
                    return renderAlertRow(it, index, props);
                });
            };
            var btnClasses = classnames_1.default([
                'o-btn',
                'o-btn--long',
                'o-btn--primary',
                {
                    'o-btn--loading': props.isLoading,
                },
            ]);
            var renderSaveSection = function (searchSets, title, props, isAllEmailChecked, isAllMobileChecked, alertSection, onAllEmailClicked, onAllMobileClicked, emptyTitle, emptyCaption, emptyStartNew, emptySearchNow) {
                if (!searchSets || !searchSets.length) {
                    var href = "/" + props.languageCode + "/property-search/buy";
                    return (React.createElement("div", { className: "l-gridlist js-gridlist l-gridlist--list-nopad", style: { marginBottom: '20px' } },
                        React.createElement("div", { className: "l-gridlist__body " },
                            React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                                React.createElement("div", { className: "c-jumbo__header" },
                                    React.createElement("div", { className: "c-jumbo__header-main" },
                                        React.createElement("div", { className: "c-jumbo__title" }, emptyTitle),
                                        React.createElement("div", { className: "c-jumbo__caption" }, emptyCaption))),
                                React.createElement("div", { className: "c-jumbo__body" },
                                    React.createElement("div", { className: "c-jumbo__content" },
                                        React.createElement("div", { className: "c-jumbo__content-row" }, emptyStartNew)),
                                    React.createElement("div", { className: "c-jumbo__actions" },
                                        React.createElement("a", { href: href, className: "o-btn o-btn--primary" }, emptySearchNow)))))));
                }
                return (React.createElement("div", { className: "c-tabler c-tabler--checkbox" },
                    React.createElement("div", { className: "c-tabler__head" },
                        React.createElement("div", { className: "c-tabler__row" },
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" }, title)),
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" },
                                    React.createElement("div", { onClick: onAllEmailClicked }, props.t.email),
                                    React.createElement("div", { className: "c-tabler__itemrow" },
                                        React.createElement("label", { className: "c-tabler__switch" },
                                            React.createElement("input", { type: "checkbox", className: "c-tabler__input", onChange: onAllEmailClicked, checked: isAllEmailChecked }),
                                            React.createElement("span", { className: "c-tabler__slider" })))),
                                React.createElement("div", { className: "c-tabler__item" },
                                    React.createElement("div", { onClick: onAllMobileClicked }, props.t.mobile),
                                    React.createElement("div", { className: "c-tabler__itemrow" },
                                        React.createElement("label", { className: "c-tabler__switch" },
                                            React.createElement("input", { type: "checkbox", className: "c-tabler__input", onChange: onAllMobileClicked, checked: isAllMobileChecked }),
                                            React.createElement("span", { className: "c-tabler__slider" })))),
                                React.createElement("div", { className: "c-tabler__item" }, props.t.frequency)))),
                    React.createElement("div", { className: "c-tabler__body" }, renderAlertRows(searchSets, props, alertSection))));
            };
            var renderSavedSearches = function (props) {
                return renderSaveSection(props.savedSearches, props.t.updateFromYour, props, props.isAllSavedSearchesEmailChecked, props.isAllSavedSearchesMobileChecked, AlertSections.SAVED_SEARCHES, props.onClickAllSavedSearchesEmail, props.onClickAllSavedSearchesMobile, props.t.emptyTitle, props.t.emptyCaption, props.t.emptyStartNew, props.t.emptySearchNow);
            };
            var renderFollowingPlaces = function (props) {
                return renderSaveSection(props.followingPlaces, props.t.updateFromFollows, props, props.isAllFollowingPlacesEmailChecked, props.isAllFollowingPlacesMobileChecked, AlertSections.FOLLOWINGS, props.onClickAllFollowingPlacesEmail, props.onClickAllFollowingPlacesMobile, props.t.emptyTitleFollow, props.t.emptyCaptionFollow, props.t.emptyStartNewFollow, props.t.emptySearchNow);
            };
            return (React.createElement("div", null,
                renderSavedSearches(props),
                renderFollowingPlaces(props),
                React.createElement("div", { id: "alert-news", className: "c-tabler c-tabler--checkbox" },
                    React.createElement("div", { className: "c-tabler__head" },
                        React.createElement("div", { className: "c-tabler__row" },
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" }, props.t.communicationFrom)),
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" }, props.t.email)))),
                    React.createElement("div", { className: "c-tabler__body" },
                        React.createElement("div", { className: "c-tabler__row" },
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" },
                                    React.createElement("span", { className: "fal fa-building" }),
                                    props.t.marketUpdate)),
                            React.createElement("div", { className: "c-tabler__rowgroup" },
                                React.createElement("div", { className: "c-tabler__item" },
                                    React.createElement("span", { className: "c-tabler__mobile-text" }, props.t.email),
                                    React.createElement("label", { className: "c-tabler__switch" },
                                        React.createElement("input", { id: "alert-checkbox", onChange: onMarketEnableChanged, type: "checkbox", checked: props.marketUpdate, className: "c-tabler__input" }),
                                        React.createElement("span", { className: "c-tabler__slider" }))))))),
                React.createElement("div", { className: "l-pad-content u-text-center" },
                    React.createElement("button", { id: "alert-savebtn", onClick: props.onAlertSave, className: btnClasses, disabled: props.isLoading },
                        React.createElement("span", { className: "fal fa-save" }),
                        "\u00A0\u00A0",
                        props.t.save))));
        };
        var unsubscribeButtonClass = classnames_1.default([
            'o-btn',
            'o-btn--danger',
            {
                'o-btn--loading': props.isLoading,
            },
        ]);
        return (React.createElement("div", { id: "alert-page", className: "l-container__main", style: { maxWidth: 'none' } },
            React.createElement("div", { className: "l-pad-content", style: props.unsubscribeMode ? { display: 'none' } : { display: 'block' } },
                React.createElement("div", { className: "c-page-header c-page-header--center-mobile" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.nameTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.nameCaption))),
                renderAlerts(props)),
            React.createElement("div", { className: "l-pad-content" },
                React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                    React.createElement("div", { className: "c-jumbo__header" },
                        React.createElement("div", { className: "c-jumbo__header-main" },
                            React.createElement("div", { className: "c-jumbo__title" }, props.t.unsubscribeTitle),
                            React.createElement("div", { className: "c-jumbo__caption" }, props.t.unsubscribeCaption))),
                    React.createElement("div", { className: "c-jumbo__body" },
                        React.createElement("div", { className: "c-jumbo__actions" },
                            React.createElement("button", { onClick: props.onUnsubscribeClicked, disabled: props.isLoading, className: unsubscribeButtonClass },
                                React.createElement("span", { className: "fal fa-bell-slash" }),
                                "\u00A0\u00A0",
                                props.t.unsubscribeButton))))),
            React.createElement(Megafoot_1.default, null)));
    };
    return React.createElement(MemberPage_1.default, null, renderAlert(props));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.alertPage);
